const Currency = () => {
  return (
    <>
      <div className=" display-max">
        <div className=" mt-4 mb-2 px-2">
          <b className="fs-4 fw-normal text-black">Choose a currency</b>
        </div>
        <div className=" w-50 px-2 mb-4">
          <div
            className=" input-group input-group-outline dropdown"
            id="dropdownCountries"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <input
              type="text"
              className=" form-control"
              placeholder="Select Currency"
            />
            <div>
              <span className=" input-group-text p-1 me-1">
                |<i className="ri-arrow-down-s-line fs-3 mt-1 mx-1"></i>
              </span>
            </div>
          </div>
          <div
            className="dropdown-menu dropdown-menu-animation shadow-dark dropdown-md nav-menu p-2 px-3 border-radius-2xl"
            aria-labelledby="dropdownCountries"
          >
            <div className="mt-1 dropdown-item border-radius-md mb-1 p-1">
              <a href=".">
                <div className=" d-flex justify-content-lg-start align-items-start gap-2">
                  <div>
                    <b className="text-md fw-normal text-black">
                      INR - Indian Rupee
                    </b>
                  </div>
                </div>
              </a>
            </div>
            <div className="mt-1 dropdown-item border-radius-md mb-1 p-1">
              <a href=".">
                <div className=" d-flex justify-content-lg-start align-items-start gap-2">
                  <div>
                    <b className="text-md fw-normal text-black">
                      USD - Us Dollar
                    </b>
                  </div>
                </div>
              </a>
            </div>
            <div className="mt-1 dropdown-item border-radius-md mb-1 p-1">
              <a href=".">
                <div className=" d-flex justify-content-lg-start align-items-start gap-2">
                  <div>
                    <b className="text-md fw-normal text-black">
                      NZD - New Zealand Dollar
                    </b>
                  </div>
                </div>
              </a>
            </div>
            <div className="mt-1 dropdown-item border-radius-md mb-1 p-1">
              <a href=".">
                <div className=" d-flex justify-content-lg-start align-items-start gap-2">
                  <div>
                    <b className="text-md fw-normal text-black">
                      <b className="text-md fw-normal text-black">EUR - Euro</b>
                    </b>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div className=" d-flex row justify-content-start align-items-center px-2 mb-3">
          <div className=" lh-base border-radius-2xl col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">Indian rupee</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">INR – ₹</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">
                  United States dollar
                </b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">USD – $</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">
                  Australian dollar
                </b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">AUD – $</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">Brazilian real</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">BRL – R$</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">Canadian dollar</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">CAD – $</b>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className=" d-flex row justify-content-start align-items-center px-2 mb-3">
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">Chilean peso</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">CLP – $</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">Chinese yuan</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">CNY – ￥</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">Colombian peso</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">COP – $</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">
                  Costa Rican colon
                </b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">CRC – ₡</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">Czech koruna</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">CZK – Kč</b>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className=" d-flex row justify-content-start align-items-center px-2 mb-3">
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">Danish krone</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">DKK – kr</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">Egyptian pound</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">EGP – ج.م</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">Emirati dirham</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">AED – ﺩ.ﺇ</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">Euro</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">EUR – €</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">Ghanaian cedi</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">GHS – GH₵</b>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className=" displa-mini display-mob">
        <div className=" mt-4 px-2">
          <div className=" w-100 px-2 mb-2">
            <div
              className=" input-group input-group-outline dropdown"
              id="dropdownCountries"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <input
                type="text"
                className=" form-control"
                placeholder="Select Currency"
              />
              <div>
                <span className=" input-group-text p-1 me-1">
                  |<i className="ri-arrow-down-s-line fs-3 mt-1 mx-1"></i>
                </span>
              </div>
            </div>
            <div
              className="dropdown-menu dropdown-menu-animation shadow-dark dropdown-lg nav-menu p-2 px-3 border-radius-2xl"
              aria-labelledby="dropdownCountries"
            >
              <div className="mt-1 dropdown-item border-radius-md mb-1 p-1">
                <a href=".">
                  <div className=" d-flex justify-content-lg-start align-items-start gap-2">
                    <div>
                      <b className="text-md fw-normal text-black">
                        INR - Indian Rupee
                      </b>
                    </div>
                  </div>
                </a>
              </div>
              <div className=" d-flex justify-content-lg-start align-items-start gap-2 p-1">
                <a href=".">
                  <div className=" d-flex justify-content-lg-start align-items-start gap-2">
                    <div>
                      <b className="text-md fw-normal text-black">
                        USD - Us Dollar
                      </b>
                    </div>
                  </div>
                </a>
              </div>
              <div className=" d-flex justify-content-lg-start align-items-start gap-2 p-1">
                <a href=".">
                  <div className=" d-flex justify-content-lg-start align-items-start gap-2">
                    <div>
                      <b className="text-md fw-normal text-black">EUR - Euro</b>
                    </div>
                  </div>
                </a>
              </div>
              <div className=" d-flex justify-content-lg-start align-items-start gap-2 p-1">
                <a href=".">
                  <div className=" d-flex justify-content-lg-start align-items-start gap-2">
                    <div>
                      <b className="text-md fw-normal text-black">
                        NZD - New Zealand Dollar
                      </b>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className=" justify-content-start align-items-center mb-3">
            <div className=" lh-base border-radius-2xl col language p-2">
              <a href=".">
                <div className=" ms-3">
                  <b className=" fw-normal text-black text-md">Indian rupee</b>
                  <div>
                    <b className=" fw-normal text-black-50 text-sm">INR – ₹</b>
                  </div>
                </div>
              </a>
            </div>
            <div className=" lh-base col language p-2">
              <a href=".">
                <div className=" ms-3">
                  <b className=" fw-normal text-black text-md">
                    United States dollar
                  </b>
                  <div>
                    <b className=" fw-normal text-black-50 text-sm">USD – $</b>
                  </div>
                </div>
              </a>
            </div>
            <div className=" lh-base col language p-2">
              <a href=".">
                <div className=" ms-3">
                  <b className=" fw-normal text-black text-md">
                    Australian dollar
                  </b>
                  <div>
                    <b className=" fw-normal text-black-50 text-sm">AUD – $</b>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Currency;
